import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
@Component({
    selector: 'app-otp-error',
    templateUrl: './otp-error.component.html',
    styleUrls: ['./otp-error.component.scss'],
    host: {
        class: 'app-otp-error'
    },
    standalone: false
})
export class OtpErrorComponent implements OnInit {

  constructor(
    public router: Router,
    public route: ActivatedRoute) { }

  ngOnInit(): void {}

  backToLogin() {
    this.router.navigate(['/login']);
  }
}
